/**
 * Подсчёт стажа по датам работы.
 *
 * Даты хранятся как 'YYYY-MM' (endDate === null означает «по настоящее время»),
 * все вычисления идут в целых месяцах и выполняются при рендере — цифры сами
 * сдвигаются с началом каждого нового месяца, править руками ничего не нужно.
 *
 * CommonJS без единой зависимости: файл требуется и из React (src/data/resume.js),
 * и из Node-скриптов сборки.
 */

const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
];

// 'YYYY-MM' → порядковый номер месяца, чтобы считать разницу простым вычитанием
function toMonthIndex(value) {
    const [year, month] = value.split('-').map(Number);
    return year * 12 + (month - 1);
}

function currentMonthIndex() {
    const now = new Date();
    return now.getFullYear() * 12 + now.getMonth();
}

function endMonthIndex(endDate) {
    return endDate ? toMonthIndex(endDate) : currentMonthIndex();
}

function formatMonth(value) {
    const [year, month] = value.split('-').map(Number);
    return `${MONTH_NAMES[month - 1]} ${year}`;
}

/** ('2024-05', null) → 'May 2024 — Present' */
function formatPeriod(startDate, endDate) {
    return `${formatMonth(startDate)} — ${endDate ? formatMonth(endDate) : 'Present'}`;
}

/**
 * Суммарный стаж по объединению периодов.
 * Места работы пересекались во времени (Dorfer и MeTime — с мая по сентябрь 2021),
 * поэтому простая сумма длительностей завысила бы цифру.
 */
function totalExperienceMonths(ranges) {
    if (ranges.length === 0) return 0;

    const intervals = ranges
        .map(({startDate, endDate}) => [toMonthIndex(startDate), endMonthIndex(endDate)])
        .sort((a, b) => a[0] - b[0]);

    let total = 0;
    let [from, to] = intervals[0];

    for (const [start, end] of intervals.slice(1)) {
        if (start > to) {
            total += to - from;
            from = start;
            to = end;
        } else if (end > to) {
            to = end;
        }
    }

    return total + (to - from);
}

/** 67 → '5+ years', 60 → '5 years' */
function formatTotalYears(months) {
    const years = Math.floor(months / 12);
    return months % 12 === 0 ? `${years} years` : `${years}+ years`;
}

module.exports = {
    formatMonth,
    formatPeriod,
    totalExperienceMonths,
    formatTotalYears,
};
